import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

const StyledCaption = styled.div`
  ${tw`mt-2 text-gray text-sm`}
`

const Caption = ({ text }) => {
  return (
    <StyledCaption dangerouslySetInnerHTML={{ __html: text }} />
  )
}

export default Caption
